<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view v-if="firstloading" class="child-view"></router-view>
    </transition>
  </div>
</template>
<script>
import Vue from "vue";
import wx from "weixin-js-sdk";
import config from "@/config";
import Fingerprint2 from 'fingerprintjs2'
export default {
  name: "app",
  data() {
    return {
      firstloading: false,
      transitionName: "slide-left"
    };
  },
  //监听路由的路径，可以通过不同的路径去选择不同的切换效果
  watch: {
    $route(to, from) {
      if (to.path == "/") {
        this.transitionName = "slide-right";
      } else {
        this.transitionName = "slide-left";
      }
    }
  },
  methods: {
    //获得自定义的配置文件信息
    getConfig(callback) {
      var t = this;
      //  + new Date().valueOf();
      var url = `./h_config.json`;
      var params = {};
      t.$http
        .get(url, params)
        .then(res => {
          var config = {};
          try {
            config = res.data;
          } catch (error) {
            console.log("config format error", res);
          }
          typeof callback == "function" && callback(config);
        })
        .catch(error => {
          typeof callback == "function" && callback(null, error);
        });
    },
    //获得APP内的用户信息
    getAppUserInfo(callback) {
      var t = this;
      setTimeout(function() {
        var userInfo = "";
        try {
          userInfo = Jegotrip.getUserInfo();
        } catch (e) {}

        console.log("userInfo:Jegotrip.getUserInfo()");
        console.log(userInfo);
        if (userInfo) {
          userInfo = JSON.parse(userInfo);
          typeof callback == "function" && callback(userInfo);
        } else {
          // loading.clear();
          if (t.loop < 3) {
            t.loop++;
            console.log("循环请求次数：" + t.loop);
            t.getAppUserInfo(callback);
          } else {
            t.loop = 0;
            typeof callback == "function" && callback(null, "no token");
          }
        }
        // t.getteams(t.urlData.token, t.urlData.openid);
        // t.getTeamAwards(t.urlData.openid);
      }, 200 + t.loop * 200);
    },
    changeScreen() {
      // 利用 CSS3 旋转 对根容器逆时针旋转 90 度 强制用户进行竖屏显示
      var detectOrient = function() {
        var width = document.documentElement.clientWidth,
          height = document.documentElement.clientHeight,
          //$wrapper = document.getElementsByTagName("body")[0],
          $wrapper = document.getElementById("vue"),
          style = "";
        if (width <= height) {
          // 横屏
          //        style += "width:" + width + "px;"; // 注意旋转后的宽高切换
          //        style += "height:" + height + "px;";
          //        style += "-webkit-transform: rotate(0); transform: rotate(0);";
          //        style += "-webkit-transform-origin: 0 0;";
          //        style += "transform-origin: 0 0;";
          style += "font-size:" + (width * 100) / 1125 + "px";
          var html_doc = document.getElementsByTagName("html")[0];
          html_doc.style.cssText = "font-size:" + (width * 100) / 1125 + "px";
        } else {
          // 竖屏
          style += "width:" + height + "px;";
          style += "min-height:" + width + "px;";
          style +=
            "-webkit-transform: rotate(-90deg); transform: rotate(-90deg);";
          // 注意旋转中点的处理
          style +=
            "-webkit-transform-origin: " +
            height / 2 +
            "px " +
            height / 2 +
            "px;";
          style +=
            "transform-origin: " + height / 2 + "px " + height / 2 + "px;";
          //style += "font-size:" + height * 100 / 1125 + "px;";
          //$("html").css({"font-size":(height * 100 / 1125),"overflow-y":"hidden"});
          var html_doc = document.getElementsByTagName("html")[0];
          html_doc.style.cssText =
            "font-size:" +
            (height * 100) / 1125 +
            "px;" +
            "overflow-y:" +
            "hidden;" +
            "height:" +
            height +
            "px;";
          style += "overflow-y: hidden;";
          add_tab();
          $wrapper.style.cssText = style;
        }
      };
      window.onresize = detectOrient;
      detectOrient();

      function add_tab() {
        var clone_tab = $("footer").clone();
        $("footer").remove();
        clone_tab.css({
          transform: "rotate(-90deg)",
          "transform-origin": "top right"
        });
        $("body").append(clone_tab);
        clone_tab.css({
          position: "fixed",
          right: "1.77rem",
          bottom: "4rem",
          left: "auto",
          top: "0",
          width: "11.25rem",
          height: "1.77rem"
        });
      }
    },
    //获得活动信息
    getActivityInfo() {
      var t = this;
      t._getActivityInfo()
        .then(res => {
          // t.activityInfo = res;
        })
        .catch(error => {
          console.log("_getActivityInfo error", error);
        })
        .finally(() => {
          // console.log("finally");
        });
    }
  },
  components: {},
  created() {},
  mounted() {
    var t = this;

    t.getConfig((res, error) => {
      console.log("getconfig res", res);
      console.log("getconfig error", error);
      if (res && res.baseurl) {
        console.log("getconfig baseurl", res.baseurl);
        Vue.prototype.baseurl = res.baseurl;
      }
      if (res && res.baseurl2) {
        Vue.prototype.baseurl2 = res.baseurl2;
      }
      if (res && res.hideShare) {
        Vue.prototype.hideShare = res.hideShare;
      }
      if (res && res.debug && res.debug == 1) {
        require("./assets/util/vconsole.js");
      }

      t.urlData = t._keyUrl();
      var q = t.$route.query;
      if (q.a) t.urlData = q;

      if(q.vConsole == 1){
        require("./assets/util/vconsole.js");
      }
      // t.getActivityInfo();
      //1、初始化全局参数
      var app_params = {
        share_userid: 0,
        activity_id: config.default_aid,
        cid:0,
        vChannel: "",
        vProject: "",
        vActivityId: "",
        vActivityName: ""
      };
      //2、获取历史缓存
      var app_params_cache = localStorage.getItem(config.app_params_key);
      if (app_params_cache && app_params_cache.length > 0)
        app_params = JSON.parse(app_params_cache);
      //3、替换新传入的参数
      var new_params = {};
      //3.1、从url中取参数的情况
      if (t.urlData && Object.keys(t.urlData).length > 0)
        new_params = t.urlData;
      //3.2、如果url中没有参数，可能是授权过程丢失参数，所以从授权前的login_redirect中获得参数
      //（ps1:假设页面a页面带参数，但需要授权，会被路由阻止进入app.vue。直接跳转登陆页面，登陆页面本身也会先进app.vue,登陆页面可能是不带需要更新的参数的。但是确可能需要用到这些参数。所以在这里取一下登陆前的参数）
      //（ps2:假设页面a页面带参数，但需要授权，会被路由阻止进入app.vue。直接跳转登陆页面，登陆完后跳转回来的时候可能会丢失这个参数）
      else {
        var login_redirect = localStorage.getItem("login_redirect");
        if (login_redirect) {
          login_redirect = JSON.parse(login_redirect);
          if (
            login_redirect.query &&
            Object.keys(login_redirect.query).length > 0
          )
            new_params = login_redirect.query;
        }
      }
      if (new_params.sid) app_params.share_userid = new_params.sid;
      if (new_params.a) app_params.activity_id = new_params.a;
      if (new_params.vChannel) app_params.vChannel = new_params.vChannel;
      if (new_params.vProject) app_params.vProject = new_params.vProject;
      if (new_params.vActivityId) app_params.vActivityId = new_params.vActivityId;
      if (new_params.vActivityName) app_params.vActivityName = new_params.vActivityName;
      if (new_params.cid) app_params.cid = new_params.cid;
      //4、更新缓存
      localStorage.setItem(config.app_params_key, JSON.stringify(app_params));
      //5、打印全局参数当前值
      console.log("now app_params", app_params);

      //请求活动信息成功后再渲染页面
      t._getActivityInfo()
        .then(res => {
          // 因为app.vue会先执行，_getUser需要登录才可以调用，所以先判断是否有登录信息了
          var app_login_user = localStorage.getItem(config.login_key);
          if (app_login_user && t._getBrowser() != 2) {
            // 如果绑定了就存好userid
            t._getUser(function() {});
          }
          //要用到上面的5步的通用参数，所以要写在后面，因为该活动紧急，UI不可配置，避免用户在其他活动有cid,故先注释
          // t._activityConfig(function(err, cInfo) {
          // 浏览器指纹2020.02.07
          Fingerprint2.get(function(components) {
            const values = components.map(function(component,index) {
              if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
                return component.value.replace(/\bNetType\/\w+\b/, '')
              }
              return component.value
            })
            // 生成最终id murmur   
            const murmur = Fingerprint2.x64hash128(values.join(''), 31)
            localStorage.setItem("vid", murmur);
          })
          // 获取到UI配置才可以渲染页面
          t.firstloading = true;
          // document.body.style.backgroundColor =
          //   cInfo && cInfo.bgcolor ? cInfo.bgcolor : "#45D4E8";
          // localStorage.setItem("configInfo_" + app_params.cid, cInfo);
          // localStorage.setItem("cid", app_params.cid);
          // if (cInfo && cInfo.webTitle && document.title == "抽奖活动") {
          //   document.title = cInfo.webTitle;
          // }
          // t.changeScreen();
          // });
        })
        .catch(error => {
          console.log("_getActivityInfo error", error);
        })
        .finally(() => {
          // console.log("finally");
        });

      console.log("***t.urlData-app***:", t.urlData);
      console.log("***window.location.href***:", window.location.href);
      // // 如果是分享链接点进来的，需要授权
      // if (t.urlData.isauth == 1) {
      //   t.getAuthorizationUrl();
      // }

      if (t._getBrowser() == 2) {
        //初始化微信JSSDK
        t._getJSConfig();
      }
      //如果在app内，先通过app页面接口获得用户信息
      else if (t._getBrowser() == 1) {
        var login_info = t._getLoginInfo();
        if (login_info) {
          t.getAppUserInfo((userinfo, err) => {
            if (!err) {
              //如果在app页面接口获取的用户信息与 app_login_user 中的用户信息不一致，则删除app_login_user信息，跳转登录页面

              if (
                !login_info ||
                !login_info.mobile ||
                login_info.mobile != userinfo.mobile
              )
                t.login_exp();
            }
            //无法通过页面接口获取用户信息的情况
            else t.login_exp();
          });
        }
      }
      console.log("当前版本：" + t.version);
    });
  }
};
</script>

<style src="../static/css/app_all.css"></style>
<style lang="scss" src="../static/scss/base.scss"></style>

